import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import {
  ActivateProgrammeRequest,
  CreateProgrammeRequest,
  DownloadTeamLeaderboardExcelRequest,
  SendMemberActivationCommunicationsRequest,
  UpdateProgrammeRequest,
  UploadMemberExcelRequest,
  ViewProgrammeRequest
} from './programme.types';

import {
  requestActivateProgramme,
  requestCreateProgramme,
  requestDownloadTeamLeaderboardExcel,
  requestSendMemberActivationCommunications,
  requestUpdateProgramme,
  requestUploadMemberExcel,
  requestViewAllProgrammes,
  requestViewProgramme
} from './programme.actions';

export const useProgrammeApi = () => {
  const dispatch = useDispatch();

  const createProgramme = useCallback(
    (requestData: CreateProgrammeRequest, onSuccess?: (externalReference?: string) => void) => {
      dispatch(requestCreateProgramme({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const viewAllProgrammes = useCallback(() => {
    dispatch(requestViewAllProgrammes({}));
  }, [dispatch]);

  const viewProgramme = useCallback(
    (requestData: ViewProgrammeRequest) => {
      dispatch(requestViewProgramme({ requestData }));
    },
    [dispatch]
  );

  const updateProgramme = useCallback(
    (requestData: UpdateProgrammeRequest, onSuccess?: (externalReference?: string) => void) => {
      dispatch(requestUpdateProgramme({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const activateProgramme = useCallback(
    (requestData: ActivateProgrammeRequest, onSuccess?: () => void) => {
      dispatch(requestActivateProgramme({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const downloadTeamLeaderboardExcel = useCallback(
    (requestData: DownloadTeamLeaderboardExcelRequest) => {
      dispatch(requestDownloadTeamLeaderboardExcel({ requestData }));
    },
    [dispatch]
  );

  const sendMemberActivationCommunications = useCallback(
    (requestData: SendMemberActivationCommunicationsRequest) => {
      dispatch(requestSendMemberActivationCommunications({ requestData }));
    },
    [dispatch]
  );

  const uploadMemberExcel = useCallback(
    (requestData: UploadMemberExcelRequest, onSuccess?: () => void) => {
      dispatch(requestUploadMemberExcel({ requestData, onSuccess }));
    },
    [dispatch]
  );

  return {
    createProgramme,
    viewAllProgrammes,
    viewProgramme,
    updateProgramme,
    activateProgramme,
    downloadTeamLeaderboardExcel,
    sendMemberActivationCommunications,
    uploadMemberExcel
  };
};
